import React from "react";
import "./Table.css";
import { useVisibleColumns } from "./useResponsiveColumns";

const PLACEHOLDER_WIDTHS = {
  name: "col-8",
  text: "col-5",
  numeric: "col-3",
  badge: "col-6",
};

function guessWidth(col) {
  const k = (col.key || "").toLowerCase();
  if (k === "actions") return null;
  if (k.includes("name") || k === "displayname") return PLACEHOLDER_WIDTHS.name;
  if (k.includes("power") || k.includes("device") || k.includes("count"))
    return PLACEHOLDER_WIDTHS.numeric;
  if (k.includes("category") || k.includes("type") || k.includes("status"))
    return PLACEHOLDER_WIDTHS.badge;
  return PLACEHOLDER_WIDTHS.text;
}

const TableSkeleton = ({
  columns,
  rows = 4,
  toolbar,
  header,
  className = "",
  ...rest
}) => {
  const base = "wg-table";
  const cardClasses = [`${base}__card`, className].filter(Boolean).join(" ");

  const isObjectToolbar =
    toolbar && typeof toolbar === "object" && ("left" in toolbar || "right" in toolbar);

  const renderToolbar = () => {
    if (!toolbar) return null;
    if (isObjectToolbar) {
      return (
        <div className={`${base}__toolbar`}>
          <div className={`${base}__toolbar-left`}>{toolbar.left}</div>
          <div className={`${base}__toolbar-right`}>{toolbar.right}</div>
        </div>
      );
    }
    return (
      <div className={`${base}__toolbar`}>
        <div className={`${base}__toolbar-right`}>{toolbar}</div>
      </div>
    );
  };

  const headerCellClass = (col) =>
    [
      `${base}__header-cell`,
      col.align === "center" && `${base}__header-cell--center`,
      col.align === "right" && `${base}__header-cell--right`,
    ]
      .filter(Boolean)
      .join(" ");

  const cellClass = (col) =>
    [
      `${base}__cell`,
      col.align === "center" && `${base}__cell--center`,
      col.align === "right" && `${base}__cell--right`,
    ]
      .filter(Boolean)
      .join(" ");

  const visibleColumns = useVisibleColumns(columns);

  return (
    <div {...rest} aria-hidden="true">
      {renderToolbar()}
      {header}
      <div className={cardClasses}>
        <table className={base}>
          <colgroup>
            {visibleColumns.map((col) => (
              <col
                key={col.key}
                style={col.width ? { width: col.width } : undefined}
              />
            ))}
          </colgroup>
          <thead>
            <tr className={`${base}__header-row`}>
              {visibleColumns.map((col) => (
                <th key={col.key} className={headerCellClass(col)}>
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }, (_, i) => (
              <tr key={i} className={`${base}__row`}>
                {visibleColumns.map((col) => {
                  const width = guessWidth(col);
                  return (
                    <td key={col.key} className={cellClass(col)}>
                      {width && (
                        <span className="placeholder-glow">
                          <span
                            className={`placeholder ${width}`}
                            style={{ borderRadius: 4, opacity: 0.35 }}
                          />
                        </span>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableSkeleton;
